// extracted by mini-css-extract-plugin
export default {"main":"system-requirements_main__wT87O","minmax":"system-requirements_minmax__sL4SX","requirementsBlock":"system-requirements_requirementsBlock__8HnJ5"};